import { symptomCodes } from "../models/SymptomDiary";
import {
  Treatment,
  TreatmentGetResponse,
  TreatmentSaveRequest,
  TreatmentPostRequest,
  TreatmentPutRequest,
} from "../models/Treatments";

export const getSymptomsUri = () => {
  let uri = "/measurements?fields=";
  for (let i = 0; i < symptomCodes.length; i++) {
    uri += symptomCodes[i];
    if (i < symptomCodes.length - 1) {
      uri += ",";
    }
  }
  return uri;
};

export const convertTreatmentGetResponseToTreatments = (
  response: TreatmentGetResponse[]
) => {
  const treatments: Treatment[] = [];
  response.forEach((r) => {
    treatments.push({ ...r, drugId: Number(r.drugId) });
  });
  return treatments;
};

export const convertToTreatmentPostRequest = (
  saveReq: TreatmentSaveRequest
) => {
  return {
    drugId: saveReq.drugId.split("-")[0].toString(),
    startDate: saveReq.startDate,
    endDate: saveReq.endDate,
    indicationId: saveReq.indicationId,
  } as TreatmentPostRequest;
};

export const convertToTreatmentPutRequest = (saveReq: TreatmentSaveRequest) => {
  return {
    drugId: saveReq.drugId.split("-")[0].toString(),
    startDate: saveReq.startDate,
    endDate: saveReq.endDate,
    indicationId: saveReq.indicationId,
  } as TreatmentPutRequest;
};
